import {
  createApp
} from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import firebase from "firebase/compat/app";
import "firebase/compat/analytics";
import "firebase/compat/auth";
import firebaseConfig from "./firebase/firebase-config.json";
import mitt from 'mitt';
import "./assets/css/main.css";
import "material-design-icons/iconfont/material-icons.css";
import "material-design-lite/material.min.css";
import FirebaseHelper from "./service/FirebaseHelper";

inicializaFirebase()
const auth = firebase.auth()
const navegador = checkAgent()
const manifest = validaAmbienteManifesto()
auth['languageCode'] = 'pt-BR';
const emitter = new mitt();
const imagens = getImagens();
const base_spinner = document.getElementById('base_spinner')
const app = createApp(App)
app.config.globalProperties.navegador = navegador;
app.config.globalProperties.auth = auth;
app.config.globalProperties.imagens = imagens;
app.config.globalProperties.base_spinner = base_spinner;
app.config.globalProperties.emitter = emitter;
app.config.globalProperties.project_id = firebaseConfig.result.sdkConfig.projectId;
const icondinamico = iconDinamico()
const firebaseHelper = new FirebaseHelper()



app.use(store)
  .use(router)
  //.use(money)
  .mount('#app');

function checkAgent() {
  let nav = ''
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/windows phone/i.test(userAgent)) {
    nav = 'Windows Phone';
  } else if (/windows/i.test(userAgent)) {
    nav = 'Windows';
  } else if (/android/i.test(userAgent)) {
    nav = 'Android';
  } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    nav = 'iOS';
  } else if (/mac/i.test(userAgent)) {
    nav = 'macOS';
  } else {
    nav = 'Outro sistema operacional';
  }
  return nav
}

function getImagens() {
 // console.log("firebaseConfig", `./config/imagens/${firebaseConfig.result.sdkConfig.projectId}.json`);
  let imagens = require(`./config/imagens/${firebaseConfig.result.sdkConfig.projectId}.json`)
  return imagens.images
}

async function inicializaFirebase() {
  // Configure Firebase.
  if (!window.navigator.onLine) {
    return false;
  }
  try {
    firebase.initializeApp(firebaseConfig.result.sdkConfig);
  } catch (e) {
    return false
  }
  firebase.analytics();
  window.firebase = firebase;
  return true
}

async function validaAmbienteManifesto() {
  let a = document.getElementById("manifest-link");
  let project = firebaseConfig.result.sdkConfig.projectId;
  if (project.indexOf("-dev") >= 0 || project.indexOf("-teste") >= 0) {
    a.href = "manifest-dev.json";
  } else if (project.indexOf("-hmg") >= 0 || project.indexOf("-hom") >= 0) {
    a.href = "manifest-hmg.json";
  } else {
    if (project.toLowerCase().indexOf("oabprevpr") >= 0) {
      a.href = "manifest-oabprevpr.json"
    } else {
      a.href = "manifest.json"
    }
  }

  return fetch(a.href)
    .then(res => {
      return res.json()
    }).then((ret) => {
      return ret
    })
}


async function iconDinamico() {
  let a = document.getElementById('icon-previdencia-digital');
  const icon = imagens.find((img) => img.nome === "logo_colorida_192x192")
  a.href = icon.url
  //console.log("icon dinamico href", a.href);
  return a.href
}


  // document.addEventListener('deviceready', () => {
  //   // Verifica se a plataforma é Android e a versão é maior ou igual a 6
  //   console.log("inicio permissão");
  //   //console.log("cordova.platformId", cordova.platformId);
  //   //console.log("cordova ===>", JSON.stringify(cordova, null, 2));
  //   getDownloadDir()
  //   if (cordova.platformId === 'android') {
  //     const permissions = cordova.plugins.permissions;
  //     //  console.log("cordova.permissions", permissions);
  //     // Solicita permissão para acessar o armazenamento externo
  //     permissions.requestPermission(
  //       permissions.WRITE_EXTERNAL_STORAGE,
  //       (status) => {
  //         if (!status.hasPermission) {
  //           //	alert("Permissão de armazenamento necessária!");
  //         }
  //       },
  //       () => {
  //         //	 alert("Erro ao solicitar permissão de armazenamento.");
  //       }
  //     );
  //   }
  // }, false);



// document.addEventListener('deviceready', function () {
//   // cordova.plugins.notification.local.schedule({
//   //   id: 1,
//   //   title: 'Notificação de Teste',
//   //   text: 'Esta é uma notificação local.',
//   //   trigger: { at: new Date(new Date().getTime() + 5 * 1000) }, // 5 segundos depois
//   // });

//   //console.log('Notificação agendada.');
// });

// document.addEventListener("deviceready", onDeviceReady, false);
// function onDeviceReady() {
//   console.log("file===>", JSON.stringify(cordova.file, null, 2));
// }

console.log('navegador', navegador);
const versao = await firebaseHelper.getVersaoPWA()

if (navegador === 'Windows' || navegador === 'macOS') {

  if (Number(localStorage.getItem('appVersion')) !== Number(versao)) {
     console.log("Atualizando o service worker");

    // Limpar o cache do service worker
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        const unregisterPromises = registrations.map(registration => registration.unregister());

        Promise.all(unregisterPromises)
          .then(() => {
            //       console.log("Service workers desregistrados");
            return caches.keys();
          })
          .then(cacheNames => {
            return Promise.all(
              cacheNames.map(cacheName => {
                if (cacheName !== `app-static-${versao}`) {
                  //      console.log(`Deletando cache: ${cacheName}`);
                  return caches.delete(cacheName);
                }
              })
            );
          })
          .then(() => {
            localStorage.setItem('appVersion', versao);
            localStorage.setItem('versaoreloda', 'passsou pelo reload');

            //window.location.reload(); // Recarrega a página para registrar o novo service worker
            //location.reload();
          })
          .catch(error => {
            console.error('Erro ao limpar o cache e desregistrar os service workers:', error);
          });
      });
    }

  }

  // Registrar o novo service worker
  if ('serviceWorker' in navigator && Number(localStorage.getItem('appVersion')) !== Number(versao)) {
    navigator.serviceWorker.register('/sw3.js')
      .then(registration => {
        console.log('Service worker registrado com sucesso:', registration);
      })
      .catch(error => {
        console.error('Falha ao registrar o service worker:', error);
      });
  }
}


document.addEventListener('deviceready', async function checkAppVersion()  {

  console.log("dispositivo", JSON.stringify(navegador));
  const lojaAppVersao = await firebaseHelper.getVersaoBD()
    console.log("versao loja banco main ios ", lojaAppVersao);
    console.log("versao loja  BuildInfo.versionCode main",  BuildInfo.versionCode);

  if (navegador === 'Android' || navegador === 'iOS' ) {
    
    if (lojaAppVersao > BuildInfo.versionCode) {
      console.log("Versão do app:", JSON.stringify(BuildInfo, null, 2));
      router.push('/alertacustom')
    }
  } 
})